import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle, Terminal, KeyRound, Check, Copy } from "lucide-react";
import { siteConfig, actions } from "../mock";
import { useToast } from "../hooks/use-toast";

const iconMap = {
  discord: MessageCircle,
  loadstring: Terminal,
  key: KeyRound,
};

const Landing = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [copiedId, setCopiedId] = useState(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setMounted(true), 60);
    return () => clearTimeout(t);
  }, []);

  const handleAction = async (action) => {
    if (action.id === "key") {
      navigate("/get-key");
      return;
    }
    if (action.id === "loadstring") {
      window.open("/loadstring", "_blank", "noopener,noreferrer");
      return;
    }
    if (action.copy) {
      try {
        await navigator.clipboard.writeText(action.copy);
      } catch (e) {
        // clipboard may be blocked; ignore silently
      }
      setCopiedId(action.id);
      toast({
        title: "Copiado",
        description: "Loadstring copiado al portapapeles.",
      });
      setTimeout(() => setCopiedId((c) => (c === action.id ? null : c)), 2000);
      return;
    }
    if (action.href && action.href.startsWith("http")) {
      window.open(action.href, "_blank", "noopener,noreferrer");
      return;
    }
  };

  return (
    <div className="stark-root">
      <div className="stark-glow stark-glow--tl" />
      <div className="stark-glow stark-glow--br" />
      <div className="stark-grain" />

      <main className="stark-center">
        <section
          className={`stark-card ${mounted ? "is-in" : ""}`}
          aria-label="Project Stark"
        >
          <h1 className="stark-title">{siteConfig.title}</h1>
          <p className="stark-tagline">{siteConfig.tagline}</p>

          <div className="stark-actions">
            {actions.map((action, i) => {
              const Icon = iconMap[action.id] || KeyRound;
              const isCopied = copiedId === action.id;
              return (
                <button
                  key={action.id}
                  type="button"
                  onClick={() => handleAction(action)}
                  className={`stark-btn stark-btn--${action.variant}`}
                  style={{ transitionDelay: `${140 + i * 70}ms` }}
                >
                  <span className="stark-btn__icon">
                    {isCopied ? (
                      <Check size={16} strokeWidth={2.4} />
                    ) : action.copy ? (
                      <Copy size={16} strokeWidth={2.2} />
                    ) : (
                      <Icon size={16} strokeWidth={2.2} />
                    )}
                  </span>
                  <span className="stark-btn__label">
                    {isCopied ? "Copied" : action.label}
                  </span>
                </button>
              );
            })}
          </div>

          <p className="stark-footer">
            © {siteConfig.year} {siteConfig.title}
          </p>
        </section>
      </main>
    </div>
  );
};

export default Landing;
